// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require("sanitize.css");
require("vue-directive-tooltip/src/css/index.scss");

import Vue from "./init";
import App from "./App";
import router from "./router";
import store from "./store/index";

import VeeValidate from "vee-validate";

Vue.use(VeeValidate, {
  inject: true,
  enableAutoClasses: true,
  events: "input|blur",
  dictionary: {
    en: {
      attributes: {
        username: "nickname",
        email: "e-mail",
        email_confirmation: "e-mail",
        password_confirmation: "password",
        password_old: "old password",
        gravatar_email: "gravatar e-mail",
        first_name: "first name",
        last_name: "last name",
        country_code: "country",
        state_code: "state",
        terms: "Terms"
      },
      custom: {
        username: {
          regex: "Only alpha-numeric characters and .'_- are allowed"
        },
        terms: {
          checked: "You must accept the User Agreement & Privacy Policy"
        },
        appId: {
          required:
            "You have to select an App for which you want to generate a game server token"
        }
      }
    }
  }
});

import { Validator } from "vee-validate";
import { unique as validatorUnique } from "./validators/unique";
import { notEmail as validatorNotEmail } from "./validators/notEmail";
import { passwordStrength as validatorPasswordStrenght } from "./validators/passwordStrength";
import { isBoolean as validatorIsBoolean } from "./validators/boolean";
import { checked as validatorChecked } from "./validators/checked";

Validator.extend("unique", validatorUnique);
Validator.extend("not-email", validatorNotEmail);
Validator.extend("password-strength", validatorPasswordStrenght);
Validator.extend("boolean", validatorIsBoolean);
Validator.extend("checked", validatorChecked);

import Alert from "@/components/partials/Alert";

Vue.component("Alert", Alert);

import PageWrapper from "@/components/partials/PageWrapper";

Vue.component("PageWrapper", PageWrapper);

import SectionWrapper from "@/components/partials/SectionWrapper";

Vue.component("SectionWrapper", SectionWrapper);

import SectionHeader from "@/components/partials/SectionHeader";

Vue.component("SectionHeader", SectionHeader);

import SectionFooter from "@/components/partials/SectionFooter";

Vue.component("SectionFooter", SectionFooter);

import Icon from "@/components/partials/Icon";

Vue.component("Icon", Icon);

import Captcha from "@/components/partials/Captcha";

Vue.component("Captcha", Captcha);

import Divider from "@/components/partials/Divider";

Vue.component("Divider", Divider);

import DividerSeparator from "@/components/partials/DividerSeparator";

Vue.component("DividerSeparator", DividerSeparator);

import DecoratedButton from "@/components/partials/Button";

Vue.component("DecoratedButton", DecoratedButton);

import FieldWrapper from "@/components/partials/FieldWrapper";

Vue.component("FieldWrapper", FieldWrapper);

import Tooltip from "vue-directive-tooltip";

Vue.use(Tooltip);

import VueFractionGrid from "vue-fraction-grid";

Vue.use(VueFractionGrid, {
  container: "980px",
  gutter: "2em",
  approach: "desktop-first",
  breakpoints: {
    compact: "415px",
    tablet: "1100px"
  }
});

Vue.config.productionTip = false;

import * as pages from "@/router/pageNameConstants";
import * as events from "@/events";
import * as services from "@/services";
import { EventBus } from "@/EventBus";
import validatorDefinitions from "@/validators/definitions";

Vue.use(function(Vue) {
  Vue.mixin({
    created: function() {
      this.pages = pages;
      this.events = events;
      this.services = services;
      this.EventBus = EventBus;
      this.validatorDefinitions = validatorDefinitions;
    }
  });
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
  http: {
    root: "/api"
  }
});
